import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import SupportTopicsBlockData from '../../../Models/Content/SupportTopicsBlockData';
import SupportTopics from './SupportTopicsBlock';

export default class SupportTopicsBlock extends EpiComponent<SupportTopicsBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = [];

    return (
      <div className={cssClasses.join(" ")}>
            <SupportTopics iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}
